import * as constants from '../constants';



export interface SessionStarted {
  type: constants.SESSION_STARTED;
  sessionId: string;
}


export const sessionStarted = (sessionId: string): SessionStarted => {
  return {
    sessionId,
    type: constants.SESSION_STARTED,
  };
};




export type SessionAction = SessionStarted;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/session.ts